import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useLinkTextToAvoidInJobSearchesState() {
  return useAppState();
}

export function useLinkTextToAvoidInJobSearchesActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      linkTexts: [],
      newLinkTextValue: '',
      deleteLinkTextModalIsOpen: false,
      linkTextToDelete: null,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function setNewLinkTextValue(value) {
    dispatch((appState) => ({
      ...appState,
      newLinkTextValue: value,
    }));
  }

  function clearNewLinkTextValue() {
    dispatch((appState) => ({
      ...appState,
      newLinkTextValue: '',
    }));
  }

  function openDeleteLinkTextModal(linkText) {
    dispatch((appState) => ({
      ...appState,
      deleteLinkTextModalIsOpen: true,
      linkTextToDelete: linkText,
    }));
  }

  function closeDeleteLinkTextModal() {
    dispatch((appState) => ({
      ...appState,
      deleteLinkTextModalIsOpen: false,
      linkTextToDelete: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    clearFeedback,
    setNewLinkTextValue,
    clearNewLinkTextValue,
    openDeleteLinkTextModal,
    closeDeleteLinkTextModal,
  };
}
